import { generatePath } from 'react-router-dom'
import { TEMPLATES_PATH } from 'paths'
import { Workspace } from 'types'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Templates } from 'blaze-ui/icons'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuTemplatesPageItem = ({ workspace, onPress }: Props) => (
  <NavMenuItem
    icon={Templates}
    activeIcon={Templates}
    to={generatePath(TEMPLATES_PATH, { workspaceId: workspace.id })}
    onPress={onPress}
    label="Templates"
  />
)

export { NavMenuTemplatesPageItem }
